"use strict";

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
  }
  return to;
};
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);

// src/react/index.ts
var react_exports = {};
__export(react_exports, {
  Experiment: () => ExperimentComponent,
  ExperimentContext: () => ExperimentContext,
  FEATURE_MANAGEMENT_USER_ID_KEY: () => FEATURE_MANAGEMENT_USER_ID_KEY,
  FeatureConfig: () => FeatureConfig_default,
  FeatureConfigContext: () => FeatureConfigContext,
  FeatureManagementContext: () => FeatureManagementContext,
  FeatureManagementProvider: () => FeatureMangementProvider_default,
  FeatureToggle: () => FeatureToggleComponent,
  FeatureToggleContext: () => FeatureToggleContext,
  StoreToggle: () => StoreToggleComponent,
  createExperimentVariationHotjarEvent: () => createExperimentVariationHotjarEvent,
  createFeatureManagementUser: () => createFeatureManagementUser,
  createFeatureToggleValue: () => createFeatureToggleValue,
  createStatsigUser: () => createStatsigUser,
  createStoreToggleValue: () => createStoreToggleValue,
  defaultFeatureManagementContext: () => defaultFeatureManagementContext,
  getFeatureManagementUserId: () => getFeatureManagementUserId,
  getValidExperimentVariation: () => getValidExperimentVariation,
  googleAnalyticsEvent: () => googleAnalyticsEvent,
  hotjarEvent: () => hotjarEvent,
  trackExperimentVariation: () => trackExperimentVariation,
  useExperiment: () => useExperiment,
  useFeatureConfig: () => useFeatureConfig,
  useFeatureToggle: () => useFeatureToggle,
  useGetExperiment: () => useGetExperiment,
  useStoreToggle: () => useStoreToggle
});
module.exports = __toCommonJS(react_exports);

// src/common/helpers.ts
var getValidExperimentVariation = variation => {
  switch (variation) {
    case "control":
      return "control";
    case "variant":
      return "variant";
    default:
      return null;
  }
};

// src/react/FeatureManagementProvider/FeatureMangementProvider.tsx
var import_react2 = require("react");
var import_react_bindings = require("@statsig/react-bindings");
var import_react3 = require("@printdeal/consent-management/react");

// src/react/FeatureManagementProvider/context.ts
var import_react = require("react");
var defaultFeatureManagementContext = {
  isInitialized: false,
  isInitializing: true,
  user: {
    store: ""
  }
};
var FeatureManagementContext = (0, import_react.createContext)(defaultFeatureManagementContext);

// src/react/FeatureManagementProvider/helpers.ts
var import_nanoid = require("nanoid");
var FEATURE_MANAGEMENT_USER_ID_KEY = "FEATURE_MANAGEMENT_USER_ID";
var getFeatureManagementUserId = () => {
  if (typeof window === "undefined") {
    return null;
  }
  const storedId = window.localStorage.getItem(FEATURE_MANAGEMENT_USER_ID_KEY);
  if (storedId) {
    return storedId;
  }
  const generatedId = (0, import_nanoid.nanoid)();
  window.localStorage.setItem(FEATURE_MANAGEMENT_USER_ID_KEY, generatedId);
  return generatedId;
};
var createStatsigUser = _ref => {
  let {
    id,
    store,
    email,
    locale,
    custom = {}
  } = _ref;
  return {
    userID: id,
    email,
    locale,
    custom: __spreadProps(__spreadValues({}, custom), {
      store
    })
  };
};
var createFeatureManagementUser = _ref2 => {
  let {
    userID,
    email,
    locale,
    custom
  } = _ref2;
  return {
    id: userID,
    store: custom == null ? void 0 : custom.store,
    email,
    locale,
    custom
  };
};

// src/react/FeatureManagementProvider/FeatureMangementProvider.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var FeatureManagementContextProvider = _ref3 => {
  let {
    statsigUser,
    children,
    environment
  } = _ref3;
  const {
    client
  } = (0, import_react_bindings.useStatsigClient)();
  const {
    updateUserAsync
  } = (0, import_react_bindings.useStatsigUser)();
  const consent = (0, import_react3.useConsent)();
  const context = (0, import_react2.useMemo)(() => {
    const isInitialized = client.loadingStatus === "Ready";
    return {
      isInitialized,
      isInitializing: !isInitialized,
      environment,
      user: createFeatureManagementUser(statsigUser)
    };
  }, [client.loadingStatus, statsigUser, environment]);
  (0, import_react2.useEffect)(() => {
    updateUserAsync(statsigUser);
  }, [statsigUser]);
  (0, import_react2.useEffect)(() => {
    if (environment !== "test") {
      client.updateRuntimeOptions({
        disableStorage: !consent.statistics,
        disableLogging: !consent.statistics
      });
    }
  }, [client, consent.statistics, environment]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(FeatureManagementContext.Provider, {
    value: context,
    children
  });
};
var FeatureManagementProvider = _ref4 => {
  let {
    children,
    user,
    apiKey,
    environment
  } = _ref4;
  const statsigUser = (0, import_react2.useMemo)(() => createStatsigUser(__spreadProps(__spreadValues({}, user), {
    id: getFeatureManagementUserId() || ""
  })), [user]);
  const options = (0, import_react2.useMemo)(() => ({
    environment: {
      tier: environment
    },
    networkConfig: {
      api: "https://ncovven2ltmfcw5veckj42bifq0vxdak.lambda-url.ap-south-1.on.aws/v1/"
    },
    disableStorage: true,
    disableLogging: true
  }), [environment]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_bindings.StatsigProvider, {
    sdkKey: apiKey,
    options,
    user: statsigUser,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(FeatureManagementContextProvider, {
      statsigUser,
      environment,
      children
    })
  });
};
var FeatureMangementProvider_default = FeatureManagementProvider;

// src/react/FeatureToggle/hooks.ts
var import_react4 = require("react");
var import_react_bindings2 = require("@statsig/react-bindings");
var useFeatureToggle = (id, onInitialized) => {
  const featureManagementContext = (0, import_react4.useContext)(FeatureManagementContext);
  const config = (0, import_react_bindings2.useFeatureGate)(id);
  const context = (0, import_react4.useMemo)(() => __spreadProps(__spreadValues({}, featureManagementContext), {
    featureToggle: {
      id: config.name,
      isEnabled: featureManagementContext.environment === "test" ? false : config.value
    }
  }), [config, featureManagementContext]);
  (0, import_react4.useEffect)(() => {
    if (featureManagementContext.isInitialized && featureManagementContext.environment !== "test") {
      onInitialized == null ? void 0 : onInitialized(context);
    }
  }, [context, featureManagementContext.isInitialized, featureManagementContext.environment, onInitialized]);
  return context;
};

// src/react/FeatureToggle/context.ts
var import_react5 = require("react");
var FeatureToggleContext = (0, import_react5.createContext)(__spreadProps(__spreadValues({}, defaultFeatureManagementContext), {
  featureToggle: {
    id: "",
    isEnabled: false
  }
}));

// src/react/FeatureToggle/FeatureToggle.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var FeatureToggle = _ref5 => {
  let {
    id,
    children,
    fallback,
    onInitialized
  } = _ref5;
  const context = useFeatureToggle(id, onInitialized);
  if (!context.isInitialized && fallback) {
    return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_jsx_runtime2.Fragment, {
      children: typeof fallback === "function" ? fallback(context) : fallback
    });
  }
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(FeatureToggleContext.Provider, {
    value: context,
    children: typeof children === "function" ? children(context) : children
  });
};
var FeatureToggle_default = FeatureToggle;

// src/react/FeatureToggle/FeatureToggle.Value.tsx
var import_react6 = require("react");
var import_jsx_runtime3 = require("react/jsx-runtime");
var FeatureToggleValue = _ref6 => {
  let {
    value,
    children
  } = _ref6;
  const context = (0, import_react6.useContext)(FeatureToggleContext);
  if (context.featureToggle.isEnabled !== value) {
    return null;
  }
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_jsx_runtime3.Fragment, {
    children: typeof children === "function" ? children(context) : children
  });
};
var FeatureToggle_Value_default = FeatureToggleValue;

// src/react/FeatureToggle/index.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var createFeatureToggleValue = value => {
  const State = props => /* @__PURE__ */(0, import_jsx_runtime4.jsx)(FeatureToggle_Value_default, __spreadProps(__spreadValues({}, props), {
    value
  }));
  State.displayName = "FeatureToggle.".concat(value ? "Enabled" : "Disabled");
  return State;
};
var FeatureToggleEnabled = createFeatureToggleValue(true);
var FeatureToggleDisabled = createFeatureToggleValue(false);
var FeatureToggleComponent = FeatureToggle_default;
FeatureToggleComponent.Disabled = FeatureToggleDisabled;
FeatureToggleComponent.Enabled = FeatureToggleEnabled;

// src/react/FeatureConfig/hooks.ts
var import_react7 = require("react");
var import_react_bindings3 = require("@statsig/react-bindings");
var useFeatureConfig = (id, onInitialized) => {
  const featureManagementContext = (0, import_react7.useContext)(FeatureManagementContext);
  const config = (0, import_react_bindings3.useDynamicConfig)(id);
  const context = (0, import_react7.useMemo)(() => __spreadValues({
    featureConfig: {
      id: config.name,
      variables: config.value
    }
  }, featureManagementContext), [config, featureManagementContext]);
  (0, import_react7.useEffect)(() => {
    if (featureManagementContext.isInitialized && featureManagementContext.environment !== "test") {
      onInitialized == null ? void 0 : onInitialized(context);
    }
  }, [context, featureManagementContext.isInitialized, featureManagementContext.environment, onInitialized]);
  return context;
};

// src/react/FeatureConfig/context.ts
var import_react8 = require("react");
var FeatureConfigContext = (0, import_react8.createContext)(__spreadProps(__spreadValues({}, defaultFeatureManagementContext), {
  featureConfig: {
    id: "",
    variables: {}
  }
}));

// src/react/FeatureConfig/FeatureConfig.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var FeatureConfig = _ref7 => {
  let {
    children,
    fallback,
    id,
    onInitialized
  } = _ref7;
  const context = useFeatureConfig(id, onInitialized);
  if (!context.isInitialized && fallback) {
    return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_jsx_runtime5.Fragment, {
      children: typeof fallback === "function" ? fallback(context) : fallback
    });
  }
  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(FeatureConfigContext.Provider, {
    value: context,
    children: typeof children === "function" ? children(context) : children
  });
};
var FeatureConfig_default = FeatureConfig;

// src/react/Experiment/hooks.ts
var import_react9 = require("react");
var import_react_bindings4 = require("@statsig/react-bindings");

// src/react/Experiment/helpers.ts
function hj() {
  for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
    rest[_key] = arguments[_key];
  }
  (window.hj.q = window.hj.q || []).push(rest);
}
function hotjarEvent(eventName) {
  if (typeof window !== "undefined") {
    window.hj = window.hj || hj;
    window.hj("event", eventName);
  }
}
function googleAnalyticsEvent(event, parameters) {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(__spreadValues({
      event
    }, parameters));
  }
}
var createExperimentVariationHotjarEvent = experiment => "".concat(experiment.id, "_").concat(experiment.variation);
var trackExperimentVariation = experiment => {
  googleAnalyticsEvent("gaEvent", {
    gaEvent: {
      eventCategory: "Experimentation",
      eventAction: "Experiment - ".concat(experiment.id),
      eventLabel: "Variation - ".concat(experiment.variation),
      eventNonInteraction: true
    }
  });
  googleAnalyticsEvent("experimentation", {
    experiment_name: "Experiment - ".concat(experiment.id),
    experiment_variant: "Variation - ".concat(experiment.variation)
  });
  hotjarEvent(createExperimentVariationHotjarEvent(experiment));
};

// src/react/Experiment/hooks.ts
var useExperiment = (id, _onInitialized) => {
  const featureManagementContext = (0, import_react9.useContext)(FeatureManagementContext);
  const config = (0, import_react_bindings4.useExperiment)(id);
  const onInitialized = (0, import_react9.useMemo)(() => _onInitialized || (_ref8 => {
    let {
      experiment
    } = _ref8;
    if (experiment.variation) {
      trackExperimentVariation(experiment);
    }
  }), [_onInitialized]);
  const context = (0, import_react9.useMemo)(() => {
    var _a;
    const {
      variation
    } = config.value;
    return __spreadProps(__spreadValues({}, featureManagementContext), {
      experiment: {
        id: config.name,
        variation: featureManagementContext.environment === "test" ? "control" : getValidExperimentVariation(variation),
        // eslint-disable-next-line no-underscore-dangle
        isActive: ((_a = config.__evaluation) == null ? void 0 : _a.is_experiment_active) || false,
        variables: config.value
      }
    });
  }, [config, featureManagementContext]);
  (0, import_react9.useEffect)(() => {
    if (featureManagementContext.isInitialized && featureManagementContext.environment !== "test") {
      onInitialized(context);
    }
  }, [context, featureManagementContext.isInitialized, featureManagementContext.environment, onInitialized]);
  return context;
};
var useGetExperiment = () => {
  const featureManagementContext = (0, import_react9.useContext)(FeatureManagementContext);
  const {
    getExperiment: getStatsigExperiment
  } = (0, import_react_bindings4.useStatsigClient)();
  const getExperiment = (0, import_react9.useCallback)((id, _onInitialized) => {
    var _a;
    const config = getStatsigExperiment(id);
    const {
      variation
    } = config.value;
    const onInitialized = _onInitialized || (_ref9 => {
      let {
        experiment
      } = _ref9;
      if (experiment.variation) {
        trackExperimentVariation(experiment);
      }
    });
    const context = __spreadProps(__spreadValues({}, featureManagementContext), {
      experiment: {
        id: config.name,
        variation: featureManagementContext.environment === "test" ? "control" : getValidExperimentVariation(variation),
        // eslint-disable-next-line no-underscore-dangle
        isActive: ((_a = config.__evaluation) == null ? void 0 : _a.is_experiment_active) || false,
        variables: config.value
      }
    });
    if (featureManagementContext.isInitialized && featureManagementContext.environment !== "test") {
      onInitialized(context);
    }
    return context;
  }, [featureManagementContext, getStatsigExperiment]);
  return getExperiment;
};

// src/react/Experiment/context.ts
var import_react10 = require("react");
var ExperimentContext = (0, import_react10.createContext)(__spreadProps(__spreadValues({}, defaultFeatureManagementContext), {
  experiment: {
    id: "",
    variation: null,
    isActive: false,
    variables: {}
  }
}));

// src/react/Experiment/Experiment.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var Experiment = _ref10 => {
  let {
    children,
    fallback,
    id,
    onInitialized
  } = _ref10;
  const context = useExperiment(id, onInitialized);
  if (!context.isInitialized && fallback) {
    return /* @__PURE__ */(0, import_jsx_runtime6.jsx)(import_jsx_runtime6.Fragment, {
      children: typeof fallback === "function" ? fallback(context) : fallback
    });
  }
  return /* @__PURE__ */(0, import_jsx_runtime6.jsx)(ExperimentContext.Provider, {
    value: context,
    children: typeof children === "function" ? children(context) : children
  });
};
var Experiment_default = Experiment;

// src/react/Experiment/Experiment.Control.tsx
var import_react11 = require("react");
var import_jsx_runtime7 = require("react/jsx-runtime");
var ExperimentControl = _ref11 => {
  let {
    children
  } = _ref11;
  const context = (0, import_react11.useContext)(ExperimentContext);
  if (
  // If the SDK is not yet initialized and this component is being rendered,
  // it means there is no fallback in `Experiment` parent component
  // and this component should be rendered as fallback.
  !context.isInitialized || context.experiment.variation === "control" || context.experiment.variation === null) {
    return /* @__PURE__ */(0, import_jsx_runtime7.jsx)(import_jsx_runtime7.Fragment, {
      children: typeof children === "function" ? children(context) : children
    });
  }
  return null;
};
var Experiment_Control_default = ExperimentControl;

// src/react/Experiment/Experiment.Variant.tsx
var import_react12 = require("react");
var import_jsx_runtime8 = require("react/jsx-runtime");
var ExperimentVariant = _ref12 => {
  let {
    children
  } = _ref12;
  const context = (0, import_react12.useContext)(ExperimentContext);
  if (
  // If the SDK is initialized and the variation is `variant`,
  // obviously this component should be rendered.
  context.isInitialized && context.experiment.variation === "variant") {
    return /* @__PURE__ */(0, import_jsx_runtime8.jsx)(import_jsx_runtime8.Fragment, {
      children: typeof children === "function" ? children(context) : children
    });
  }
  return null;
};
var Experiment_Variant_default = ExperimentVariant;

// src/react/Experiment/index.ts
var ExperimentComponent = Experiment_default;
ExperimentComponent.Control = Experiment_Control_default;
ExperimentComponent.Control.displayName = "Experiment.Control";
ExperimentComponent.Variant = Experiment_Variant_default;
ExperimentComponent.Variant.displayName = "Experiment.Variant";

// src/react/StoreToggle/hooks.ts
var import_react13 = require("react");
var useStoreToggle = id => {
  const featureManagementContext = (0, import_react13.useContext)(FeatureManagementContext);
  const value = (0, import_react13.useMemo)(() => id.includes(featureManagementContext.user.store), [id, featureManagementContext.user.store]);
  const context = (0, import_react13.useMemo)(() => __spreadProps(__spreadValues({}, featureManagementContext), {
    featureToggle: {
      id,
      isEnabled: value
    }
  }), [id, value, featureManagementContext]);
  return context;
};

// src/react/StoreToggle/StoreToggle.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var StoreToggle = _ref13 => {
  let {
    id,
    children
  } = _ref13;
  const context = useStoreToggle(id);
  return /* @__PURE__ */(0, import_jsx_runtime9.jsx)(FeatureToggleContext.Provider, {
    value: context,
    children: typeof children === "function" ? children(context) : children
  });
};
var StoreToggle_default = StoreToggle;

// src/react/StoreToggle/index.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");
var createStoreToggleValue = value => {
  const State = props => /* @__PURE__ */(0, import_jsx_runtime10.jsx)(FeatureToggle_Value_default, __spreadProps(__spreadValues({}, props), {
    value
  }));
  State.displayName = "StoreToggle.".concat(value ? "Enabled" : "Disabled");
  return State;
};
var StoreToggleEnabled = createStoreToggleValue(true);
var StoreToggleDisabled = createStoreToggleValue(false);
var StoreToggleComponent = StoreToggle_default;
StoreToggleComponent.Disabled = StoreToggleDisabled;
StoreToggleComponent.Enabled = StoreToggleEnabled;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Experiment,
  ExperimentContext,
  FEATURE_MANAGEMENT_USER_ID_KEY,
  FeatureConfig,
  FeatureConfigContext,
  FeatureManagementContext,
  FeatureManagementProvider,
  FeatureToggle,
  FeatureToggleContext,
  StoreToggle,
  createExperimentVariationHotjarEvent,
  createFeatureManagementUser,
  createFeatureToggleValue,
  createStatsigUser,
  createStoreToggleValue,
  defaultFeatureManagementContext,
  getFeatureManagementUserId,
  getValidExperimentVariation,
  googleAnalyticsEvent,
  hotjarEvent,
  trackExperimentVariation,
  useExperiment,
  useFeatureConfig,
  useFeatureToggle,
  useGetExperiment,
  useStoreToggle
});